import { hyperStyled } from "@macrostrat/hyper";
import styles from "./main.module.scss";

const h = hyperStyled(styles);

export default h;
